<template>
  <ButtonGroupComponent :actionButtons="getActionButtonsGroup()" />
</template>

<script>
import ButtonGroupComponent from '../base.component/ButtonGroupComponent.vue';
import ProductService from '../../services/productApiService';

export default {
  components: {
    ButtonGroupComponent,
  },

  props: {
    selectedProducts: {
      type: Array,
      required: true
    },
  },

  computed: {
    isPublished() {
      return this.checkState(true);
    },

    isUnpublished() {
      return this.checkState(false);
    },
  },

  methods: {
    getActionButtonsGroup() {
      return [
        {
          name: 'Publish',
          action: async () => await this.onPublishOrUnpublish(true),
          isDisabled: this.isPublished,
        },
        {
          name: 'Unpublish',
          action: async () => await this.onPublishOrUnpublish(false),
          isDisabled: this.isUnpublished,
        },
      ];
    },

    checkState(state) {
      let isDisabled = true;

      if (this.selectedProducts.length > 0) {
        const arr = this.selectedProducts.find(
          (product) => product.isPublished === state
        );

        if (arr === undefined) {
          isDisabled = false;
        }
      }

      return isDisabled;
    },

    async onPublishOrUnpublish(isPublishing) {
      const productsIds = this.selectedProducts.map((product) => product.id);

      if (isPublishing) {
        await ProductService.updateStateProductToPublished(productsIds);
      } else {
        await ProductService.updateStateProductToUnpublished(productsIds);
      }

      this.$emit('onDataUpdate');
    },
  },
};
</script>

<style>
</style>